import { useState } from 'react';
import beTwMerge from '@/utils/beTwMerge';
import ResponsiveImage from '@/utils/ResponsiveImage';
import { isMobileDevice } from '@/utils/utils';
import { clearHTMLTags } from '@/utils/builderUtils';
import { IHomePageItem } from '@/components/Carousel/types';
import { subHeadersStyles } from '@/consts/builder';

export const categoryCarouselUpdatedImage = src => [
  {
    src,
    size: { width: 496, aspectRatio: 248 / 287 },
    breakpoint: 320,
  },
  {
    src,
    size: { width: 572, aspectRatio: 286 / 332 },
    breakpoint: 768,
  },
  {
    src,
    size: { width: 578, aspectRatio: 289 / 335 },
    breakpoint: 1440,
  },
];

interface HomepageItemProps {
  isTextCenter?: boolean;
  isFullBleed?: boolean;
  item: IHomePageItem;
}
export default function HomepageItem({ isTextCenter = false, isFullBleed = false, item }: HomepageItemProps) {
  const [isOnHover, setIsOnHover] = useState(false);

  return (
    <div className="tw-col-span-1" key={item.imgSrcs}>
      <a
        href={item.link}
        className={beTwMerge(
          'tw-w-full tw-pr-0 tw-pl-0 lg:tw-pl-0 tw-inline-block hover:tw-no-underline tw-cursor-default focus:tw-outline-none tw-group',
          item.link ? 'hover:tw-text-color-[#599d8e] tw-cursor-pointer' : 'hover:tw-text-color-black'
        )}
        aria-label={item.link ? `${item.name} ${clearHTMLTags(item.description || '')}` || item.altText : undefined}
        role={item.link ? undefined : 'presentation'}
        tabIndex={item.link ? 0 : -1}
      >
        <div className="tw-relative">
          <div
            className="tw-relative tw-z-10 [transition:opacity_500ms_linear] tw-aspect-[171/198] md:tw-aspect-[235/273] lg:tw-aspect-[209/242]"
            onTouchEnd={event => {
              if (!item?.link) {
                event.preventDefault();
              }
            }}
            onMouseEnter={() => {
              if (item?.hoverImage && !isMobileDevice()) {
                setIsOnHover(true);
              }
            }}
            onMouseLeave={() => {
              if (item?.hoverImage) {
                setIsOnHover(false);
              }
            }}
          >
            <ResponsiveImage
              className={beTwMerge('tw-w-full tw-h-full tw-object-cover', isOnHover ? '!tw-hidden' : '!tw-block')}
              sources={categoryCarouselUpdatedImage(item.imgSrcs)}
              alt={item.altText || item.name}
            />
            <ResponsiveImage
              className={beTwMerge('tw-w-full tw-h-full tw-object-cover', isOnHover ? '!tw-block' : '!tw-hidden')}
              sources={categoryCarouselUpdatedImage(item.hoverImage)}
              alt={item.HoverImageAltText}
            />
          </div>
          <div
            className={beTwMerge('tw-absolute tw-inset-x-0 tw-inset-y-0 tw-bg-color-grey-50 tw-pointer-events-none')}
          />
        </div>

        {item.name && (
          <h4
            className={beTwMerge(
              'tw-no-underline tw-mt-2 md:tw-mt-4 tw-mb-0 tw-font-medium',
              subHeadersStyles['h4'],
              isFullBleed && 'desktop:tw-ml-[8px]',
              isTextCenter && 'tw-text-center'
            )}
          >
            {item.name}
          </h4>
        )}
        {item.description && (
          <div
            className={beTwMerge(
              'tw-font-book tw-mt-2 tw-mb-0 !tw-text-color-black [&>p]:tw-mb-0',
              isTextCenter && 'tw-text-center'
            )}
            dangerouslySetInnerHTML={{ __html: item.description }}
          />
        )}
      </a>
    </div>
  );
}
